import { useQuery } from '@tanstack/react-query';

import { formatData } from 'components/helpers/reactQuery';

export function useProjectsAnalyticsFilterSelectionConfigurationQuery({
  queryOptions,
}) {
  return useQuery({
    queryKey: ['projectsAnalyticsFilterSelectionConfiguration'],
    queryFn: async () => {
      const response = await axios.get(
        '/projects_analytics/filter_selection_configuration',
      );

      return response.data;
    },
    enabled: queryOptions.initialData.meta.isBulkUpdateInProgress,
    refetchInterval: (data) =>
      data?.meta.isBulkUpdateInProgress ? 1000 : false,
    refetchIntervalInBackground: true,
    select: (data) =>
      formatData({
        data,
        resourceTypes: ['company', 'companyFilterSelection'],
      }),
    ...queryOptions,
  });
}
